export default {
	FUEL: 'fuel',
	POTENTIAL: 'potential',
	CLIENTS: 'clients',
	DRIVER_STATEMENTS: 'driverStatements',
	BONUS_CHARGE: 'bonusCharge',
	SAFETY: 'safety',
	WORK_ORDERS: 'work_orders',
	STATISTICS: 'statistics',
	INVOICE: 'invoice',
	TRUCKS: 'trucks',
	MANAGER_STATEMENTS: 'managerStatements',
	USERS: 'users',
	CITIES: 'cities',
	TRIPS: 'trips',
	CUSTOMER_PAYMENTS: 'customerPayments',
	LOST_PAYMENTS: 'lostPayments',
	CUSTOMER_INVOICE_ITEMS: 'customerInvoiceItems',
	LOGBOOKS_MOD: 'logbooksMod',
};
